// todo: keep on eye about https://github.com/nfl/react-helmet/issues/426
// We're having warn about componentWillMount on SideEffect(NullComponent), react-helmet's dependency
import { PropsWithChildren } from 'react'
import { Helmet } from 'react-helmet'

import { st } from 'lib/helpers'

type Props = {
  title: string
  description: string
  image?: string
}

const SeoHeader = ({
  title,
  description,
  image,
  children,
}: PropsWithChildren<Props>) => {
  const _title = title || st('home.title')
  const _description = description || st('home.description')

  return (
    <Helmet>
      <title>{_title}</title>
      <meta name="og:title" content={_title} />
      <meta name="twitter:title" content={_title} />
      <meta name="description" content={_description} />
      <meta name="og:description" content={_description} />
      <meta name="twitter:description" content={_description} />
      {/* cannot use fragment in helmet */}
      {image && <meta name="og:image" content={image} />}
      {image && <meta name="twitter:image" content={image} />}

      {children}
    </Helmet>
  )
}

export default SeoHeader
